import { defineComponent as _defineComponent } from 'vue'
import Loading from "@/components/home/Loading.vue";
import Alert from "@/components/scan/parts/Alert.vue";
import SendEmailService from "@/services/SendEmailService";
import UserApprovalDataService from "@/services/UserApprovalDataService";
import UserInfoDataService from "@/services/UserInfoDataService";
import { store } from "@/store/store";
import ResponseData from "@/types/ResponseData";
import { onMounted, onBeforeUnmount, onUpdated, reactive, ref } from "vue";
import { useI18n } from "vue3-i18n";
import AdminNavigation from "../../AdminNavigationContainer.vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {
  expose();

const isLoading = ref(false);
const userApprovalInfo = reactive([]);
const permissionSetInfo = reactive([]);
const rePermissionInfo = reactive([]);
const alertMessage = ref("null");
const alertState = ref("neutral");
const i18n = useI18n();
const title = ref("User Approval");
const modalSubject = reactive([]);
const modalBody = reactive([]);
const approveModalSubject = reactive([]);
const approveModalBody = reactive([]);
const isNoData = ref(false);
const userType = ref("null");
const isEditableAuthID = ref(false);
const targetUserId = ref("null");
const threeDigitCode = ref("null");
const targetstationCode = ref("null");
const targetEmpNo = ref("null");
const targetGivenName = ref("null");
const targetFamilyName = ref("null");
const targetCompanyName = ref("null");
const targetemail = ref("null");
const targetUserName = ref("null");
const targetStation3Digit = ref("");
const oriAuthID = ref("");
const authIDFormatError = ref("");
const isConfirmFlg = ref(false);
const editedAuthIDApproveData = reactive([]);

/** 初期表示設定 */
onMounted(function () {
  window.addEventListener('resize', handleResize);
  alertMessage.value = "null";
  alertState.value = "neutral";
  isLoading.value = true;
  getUserApprovalInfo();
  getPermissionSetInfo();
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', handleResize);
});

function handleResize() {
  try {
    var tableHeight = 0;
    var dataHeight = document.getElementById("tbltbody")?.clientHeight;
    if (dataHeight != 0) {
      tableHeight = document.getElementById("tblbodydiv")?.clientHeight;
      if (dataHeight > tableHeight) {
        document.getElementById("tblbodydiv").style.width = "100%";
      } else {
        document.getElementById("tblbodydiv").style.width = "calc(100% - 16px)";
      }
    }
  } catch (e) {
    isLoading.value = false;
  }
}

/** 対象承認ユーザー、ユーザーによる権限と権限明細情報取得 */
const getUserApprovalInfo = () => {
  isLoading.value = true;
  userApprovalInfo.splice(0);

  alertMessage.value = "null";
  alertState.value = "neutral";

  // ログインユーザーのステーションコード
  const data = { stationCode: store.getters.stationCode };
  UserApprovalDataService.getUserApprovalInfo(data)
    .then((response: ResponseData) => {
      if (response.data.length !== 0) {
        userApprovalInfo.push(response.data);
        isNoData.value = false;
      } else {
        isNoData.value = true;
      }
      isLoading.value = false;
    })
    .catch((e: Error) => {
      alertMessage.value = i18n.t("err012");
      alertState.value = "error";
      isLoading.value = false;
      console.log(e);
    });
};

/** ユーザーの権限をチェックの為、メインメニューからデータ取得 */
const getPermissionSetInfo = () => {
  isLoading.value = true;
  permissionSetInfo.splice(0);

  //二回目実行にアラートメッセージが表示修正
  alertMessage.value = "null";
  alertState.value = "neutral";

  const data = { stationCode: store.getters.stationCode };
  UserInfoDataService.getPermissionDetailforApproval(data)
    .then((response: ResponseData) => {
      if (response.data.length !== 0) {
        permissionSetInfo.push(response.data);
      }
      isLoading.value = false;
    })
    .catch((e: Error) => {
      alertMessage.value = i18n.t("err014");
      alertState.value = "error";
      isLoading.value = false;
      console.log(e);
    });
};

/** プレビューボタン押下時の処理関数 */
const modalShow1 = (strobj) => {
  modalSubject.splice(0);
  modalSubject.push("Permission Set");
  alertMessage.value = "null";
  alertState.value = "neutral";
  userType.value = strobj.chkUser;
  targetUserId.value = strobj.userId;
  targetEmpNo.value = strobj.employeeNumber;
  targetGivenName.value = strobj.givenName;
  targetFamilyName.value = strobj.familyName;
  targetCompanyName.value = strobj.companyName;
  targetstationCode.value = strobj.stationCode;
  targetemail.value = strobj.email;
  targetUserName.value = strobj.givenName + " " + strobj.familyName;

  checkCheckBox(strobj);
};

const checkCheckBox = (strobj1) => {
  var checkCount = 0;

  // 最初にチェックをdeselectにする
  for (var t = 0; t < permissionSetInfo[0].length; t++) {
    if (permissionSetInfo[0][t].data.length != 0) {
      document.getElementById(
        "chkHeader" + permissionSetInfo[0][t].mainTitleCode
      ).checked = false;
      document.getElementById(
        "chkHeader" + permissionSetInfo[0][t].mainTitleCode
      ).disabled = false;
    }
    for (var s = 0; s < permissionSetInfo[0][t].data.length; s++) {
      document.getElementById(
        "chk" + permissionSetInfo[0][t].data[s].mainMenuCode
      ).checked = false;
      document.getElementById(
        "chk" + permissionSetInfo[0][t].data[s].mainMenuCode
      ).disabled = false;
    }
  }

  // 対象ユーザーの為権限があるサブメニューにチェック付ける
  for (var m = 0; m < userApprovalInfo[0].length; m++) {
    if (
      strobj1.chkUser == "TmpUser" &&
      userApprovalInfo[0][m].employeeNumber == strobj1.employeeNumber
    ) {
      for (var n = 0; n < userApprovalInfo[0][m].data.length; n++) {
        if (
          document.getElementById(
            "chk" + userApprovalInfo[0][m].data[n].mainMenuCode
          ) != null
        ) {
          document.getElementById(
            "chk" + userApprovalInfo[0][m].data[n].mainMenuCode
          ).checked = true;
        }
      }
    } else if (
      strobj1.chkUser == "ReAppUser" &&
      userApprovalInfo[0][m].userId == strobj1.userId
    ) {
      for (var k = 0; k < userApprovalInfo[0][m].data.length; k++) {
        if (
          document.getElementById(
            "chk" + userApprovalInfo[0][m].data[k].mainMenuCode
          ) != null
        ) {
          if (
            userApprovalInfo[0][m].data[k].status == "2" ||
            userApprovalInfo[0][m].data[k].status == "3"
          ) {
            document.getElementById(
              "chk" + userApprovalInfo[0][m].data[k].mainMenuCode
            ).disabled = true;
          } else {
            document.getElementById(
              "chk" + userApprovalInfo[0][m].data[k].mainMenuCode
            ).checked = true;
          }
        }
      }
    }
  }

  // Subに全部の権限がある場合、Mainにチェックする為
  for (var x = 0; x < permissionSetInfo[0].length; x++) {
    checkCount = 0;
    for (var y = 0; y < permissionSetInfo[0][x].data.length; y++) {
      if (
        document.getElementById(
          "chk" + permissionSetInfo[0][x].data[y].mainMenuCode
        ).checked &&
        document.getElementById(
          "chk" + permissionSetInfo[0][x].data[y].mainMenuCode
        ).disabled == false
      ) {
        checkCount = checkCount + 1;
      }
    }
    if (
      permissionSetInfo[0][x].data.length == checkCount &&
      permissionSetInfo[0][x].data.length != 0
    ) {
      document.getElementById(
        "chkHeader" + permissionSetInfo[0][x].mainTitleCode
      ).checked = true;
    }
  }
};

/** チェックボックス押下時の処理関数 */
const chkChange = (param) => {
  var chkHeaderID = "chkHeader" + param;
  var isHeaderCheck = true;
  var chkName = "chk" + param;
  var allChk = document.getElementsByName(chkName);
  // サブチェックボックスが【1】行以上ならヘッダチェックに反映する
  for (var i = 0; i < allChk.length; i++) {
    if (allChk[i].checked == false) {
      isHeaderCheck = false;
    }
  }
  document.getElementById(chkHeaderID).checked = isHeaderCheck;
};

/** ヘッダチェックボックス変更 */
const chkHeaderChange = (param) => {
  var chkHeaderID = "chkHeader" + param;
  var chkName = "chk" + param;
  var isHeaderCheck = document.getElementById(chkHeaderID).checked;
  var allChk = document.getElementsByName(chkName);
  // 各チェック未チェックの反映
  for (var i = 0; i < allChk.length; i++) {
    if (allChk[i].disabled == false) {
      allChk[i].checked = isHeaderCheck;
    }
  }
};

/** 新規ユーザーの為、プレビューの閉じるボタン押下時の処理関数 */
const btnClose = (strEmpNo, strStationCD) => {
  // クリックしたユーザーの旧権限全部を削除する
  rePermissionInfo.splice(0);
  alertMessage.value = "null";
  alertState.value = "neutral";
  const reAppUserId = strEmpNo;
  const stationCd = strStationCD;

  //ユーザーが選択した権限リスト
  for (var j = 0; j < permissionSetInfo[0].length; j++) {
    for (var k = 0; k < permissionSetInfo[0][j].data.length; k++) {
      if (permissionSetInfo[0][j].data[k].mainMenuCode) {
        const chkFlg = document.getElementById(
          "chk" + permissionSetInfo[0][j].data[k].mainMenuCode
        );
        if (chkFlg.checked == true) {
          rePermissionInfo.push(permissionSetInfo[0][j].data[k].mainMenuCode);
        }
      }
    }
  }

  if (rePermissionInfo.length > 0) {
    UserApprovalDataService.reAppUserPermissionData(
      reAppUserId,
      rePermissionInfo,
      stationCd
    )
      .then((_) => {
        getUserApprovalInfo();
        getPermissionSetInfo();
      })
      .catch((e: Error) => {
        alertMessage.value = i18n.t("err065");
        alertState.value = "error";
        isLoading.value = false;
        console.log(e);
      });
  }
};

/** 承認ボタン押下時の処理関数 */
const showApproveModal = (strAppUserInfo) => {
  approveModalSubject.splice(0);
  approveModalBody.splice(0);
  isEditableAuthID.value = false;

  //二回目実行にアラートメッセージが表示修正
  alertMessage.value = "null";
  alertState.value = "neutral";
  authIDFormatError.value = "";

  targetUserId.value = strAppUserInfo.userId;
  targetEmpNo.value = strAppUserInfo.employeeNumber;
  targetGivenName.value = strAppUserInfo.givenName;
  targetFamilyName.value = strAppUserInfo.familyName;
  targetstationCode.value = strAppUserInfo.stationCode;
  targetCompanyName.value = strAppUserInfo.companyName;
  targetemail.value = strAppUserInfo.email;
  targetUserName.value = strAppUserInfo.givenName + " " + strAppUserInfo.familyName;
  // 同じメールで複数統合ID取得のため
  targetStation3Digit.value = strAppUserInfo.digit3_cd;

  approveModalSubject.push("Approve User");
  const data = {
    userId: strAppUserInfo.employeeNumber,
    email: strAppUserInfo.email,
    stdCd: strAppUserInfo.stationCode,
  };
  UserApprovalDataService.checkUser(data)
    .then((response: ResponseData) => {
      isLoading.value = false;
      var strUserApp = response.data[0]["app"].replaceAll('"', "");
      var arrScanInfo = strUserApp.split(';');
      // 同じメールで複数統合ID登録のため
      oriAuthID.value = response.data[0]["authUserID"];
      approveModalBody.push(response.data[0]["authUserID"]);
      if (response.data[0]["type"] == "NewUser") {
        document.getElementById("txtAuthenticationId").disabled = false;
        approveModalBody.push(
          "Type 5 digits followed by 3 digit country-company code assigned by the system."
        );
        approveModalBody.push(
          "SMC expatriates must use their 6-digit SMC employee number as their User ID."
        );
        userType.value = "NewUser";
        threeDigitCode.value = response.data[0]["authUserID"];
      } else if (response.data[0]["type"] == "ExtUser") {
        isEditableAuthID.value = true;
        document.getElementById("txtAuthenticationId").disabled = true;
        approveModalBody.push(
          "Please leave 6 digit ID defined by system as it is in case of Japanese representative of SMC"
        );
        if (arrScanInfo.includes("scan")) {
          userType.value = "ScanUser";
        } else {
          userType.value = "NotScanUser";
        }
      } else {
        isEditableAuthID.value = true;
        document.getElementById("txtAuthenticationId").disabled = true;
        if (arrScanInfo.includes("scan")) {
          userType.value = "ScanUser";
          approveModalBody.push(
            "User already has SCAN ID matched by e-mail address. Go ahead to click 'Approve', if you are sure."
          );
        } else {
          userType.value = "NotScanUser";
          approveModalBody.push(
            "User already has Authentication ID matched by e-mail address but not has SCAN permission.\nGo ahead to click 'Approve',if you are sure."
          );
        }
      }
    })
    .catch((e: Error) => {
      alertMessage.value = i18n.t("err066");
      alertState.value = "error";
      isLoading.value = false;
      console.log(e);
    });
};

/** 対象ユーザーの削除処理関数 */
const showDenyModel = (userID, struserType, email, familyName, givenName) => {
  //二回目実行にアラートメッセージが表示する為修正
  alertMessage.value = "null";
  alertState.value = "neutral";

  modalSubject.splice(0);
  modalBody.splice(0);
  userType.value = struserType;
  targetUserId.value = userID;
  // 2023/05/16 MDCR 修正 start
  targetemail.value = email;
  targetUserName.value = givenName + " " + familyName;
  // 2023/05/16 MDCR 修正 end

  if (struserType == "TmpUser") {
    modalSubject.push("Deny User");
    modalBody.push("Are you really sure to deny this user?");
  } else {
    modalSubject.push("Deny Application");
    modalBody.push("Are you really sure to deny this application?");
  }
};

const DenyBtnClk = (strUserId, strUserType) => {
  //二回目実行にアラートメッセージが表示する為修正
  alertMessage.value = "null";
  alertState.value = "neutral";
  const data = {
    userId: strUserId,
    userType: strUserType,
    email: targetemail.value,
    userName: targetUserName.value,
    targetMailFormat: "mail_user_denied",
    sendingPattern: "user_denied",
    loginUserId: store.getters.cognitoUserName,
    stationCode: store.getters.stationCode
  };
  isLoading.value = true;

  UserApprovalDataService.denyUserPermission(data)
    .then((_) => {
      data.userType = "NewUser"
      SendEmailService.sendEmail(data)
        .then((_) => {
          getUserApprovalInfo();
          alertMessage.value = i18n.t("suc007");
          alertState.value = "success";
        })
        .catch((e: Error) => {
          alertMessage.value = "Failed to send completion email of user deny";
          alertState.value = "error";
          isLoading.value = false;
          console.log(e);
        });
    })
    .catch((e: Error) => {
      alertMessage.value = i18n.t("err067");
      alertState.value = "error";
      isLoading.value = false;
      console.log(e);
    });
};

/** 承認ボタン押下後表示するもダルの承認ボタン押下処理関数 */
const ApproveBtnClk = (
  strAuthID,
  struserType,
  struserID,
  strEmpID,
  strGivenNm,
  strFamilyNm,
  strStationCD,
  strCompName,
  stremail,
  strThreeDigit
) => {
  alertMessage.value = "null";
  alertState.value = "neutral";
  authIDFormatError.value = "";
  isLoading.value = true;
  if (struserType == "NewUser" || (approveModalBody[0] != oriAuthID.value)) {
    editedAuthIDApproveData.splice(0);
    editedAuthIDApproveData.push(
      {
        userType: struserType,
        userID: struserID,
        authID: strAuthID,
        empID: strEmpID,
        givenNm: strGivenNm,
        familyNm: strFamilyNm,
        stationCD: strStationCD,
        compName: strCompName,
        threeDigit: strThreeDigit,
        email: stremail
      }
    )
    var checkByEmailData = {
      email: targetemail.value,
      givenName: targetGivenName.value,
      familyName: targetFamilyName.value
    }
    UserApprovalDataService.checkAuthUserByEmail(checkByEmailData).then((resChkByEmail: ResponseData) => {
      var isContinue = false;
      if (resChkByEmail.data == "1") {
        // 名前が違うユーザーは同じメールで複数統合を申請できないので
        isConfirmFlg.value = false;
        document.getElementById("btnHiddenConfirm").click();
      } else if (resChkByEmail.data == "2") {
        // 同じユーザーが同じメールで複数統合を申請したい場合、
        isConfirmFlg.value = true;
        document.getElementById("btnHiddenConfirm").click();
      } else {
        isContinue = true;
      }
      if (isContinue) {
        EditedAuthIDApprove(editedAuthIDApproveData[0]);
      } else {
        isLoading.value = false;
        return;
      }
    })
      .catch((e: Error) => {
        alertMessage.value = i18n.t("err075");
        alertState.value = "error";
        isLoading.value = false;
        console.log(e);
      });
  } else if (struserType == "ScanUser") {
    var digitTester1 = /^[A-Za-z0-9]+$/;
    if ((strAuthID.length == 6 && digitTester1.test(strAuthID)) || (strAuthID.length == 8 && strAuthID.substring(0,3) == targetStation3Digit.value)) {
      document.getElementById("btnApproveModalCancel").click();
      const data = { authID: strAuthID, empNo: strEmpID, stationCode: strStationCD };
      UserApprovalDataService.checkAuthUser(data)
        .then((response: ResponseData) => {
          if (response.data.length !== 0) {
            if(data.authID == response.data[0].userId){
              alertMessage.value = "Failed approval. User ID is duplicated.";
            }else {
              alertMessage.value = i18n.t("err064");
            }
            alertState.value = "error";
            isLoading.value = false;
          } else {
            insertTmpUserInfo(strEmpID, strStationCD, strAuthID);
          }
        })
        .catch((e: Error) => {
          alertMessage.value = i18n.t("err068");
          alertState.value = "error";
          isLoading.value = false;
          console.log(e);
        });
    } else if ((strAuthID.length == 8 && strAuthID.substring(0,3) != targetStation3Digit.value)){
      authIDFormatError.value = i18n.t("alt071");
      isLoading.value = false;
    } else {
      authIDFormatError.value = "※Failed approval. User ID is invalid.";
      isLoading.value = false;
    }
  } else {
    var digitTester2 = /^[A-Za-z0-9]+$/;
    if ((strAuthID.length == 6 && digitTester2.test(strAuthID)) || (strAuthID.length == 8 && strAuthID.substring(0,3) == targetStation3Digit.value)) {
      document.getElementById("btnApproveModalCancel").click();
      const data = { authID: strAuthID, empNo: strEmpID, stationCode: strStationCD };
      UserApprovalDataService.checkAuthUser(data)
        .then((response: ResponseData) => {
          if (response.data.length !== 0) {
            if(data.authID == response.data[0].userId){
              alertMessage.value = "Failed approval. User ID is duplicated.";
            }else {
              alertMessage.value = i18n.t("err064");
            }
            alertState.value = "error";
            isLoading.value = false;
          } else {
            insertAuthIDInfo(
              strAuthID,
              struserType,
              struserID,
              strEmpID,
              strGivenNm,
              strFamilyNm,
              strStationCD,
              strCompName,
              stremail
            );
          }
        })
        .catch((e: Error) => {
          alertMessage.value = i18n.t("err068");
          alertState.value = "error";
          isLoading.value = false;
          console.log(e);
        });
    } else if ((strAuthID.length == 8 && strAuthID.substring(0,3) != targetStation3Digit.value)){
      authIDFormatError.value = i18n.t("alt071");
      isLoading.value = false;
    } else {
      authIDFormatError.value = "※Failed approval. User ID is invalid.";
      isLoading.value = false;
    }
  }
};

// ConfirmモダールのOKボタンクリック
const confirmAuthIDApprove = () => {
  EditedAuthIDApprove(editedAuthIDApproveData[0]);
  // フォーマットエラーがある場合、前のモダールを再表示する
  if (authIDFormatError.value.trim() != "") {
    document.getElementById("btnHiddenReOpen").click();
  }
}

// 自動セットした統合認証IDを編集して承認するため変数
const EditedAuthIDApprove = (param: any) => {
  isLoading.value = true;
  const data = { authID: param.authID, empNo: param.empID, stationCode: param.stationCD };
  var re1 = /^[A-Za-z]+$/;
  var re2 = /^[A-Za-z0-9]+$/;
  param.threeDigit = param.threeDigit != targetStation3Digit.value ? targetStation3Digit.value : param.threeDigit;
  if (param.authID.length != 8) {
    authIDFormatError.value = "※Failed approval. User ID is invalid.";
    isLoading.value = false;
  } else if (
    param.authID.substring(3).length != 5 ||
    !re2.test(param.authID.substring(3)) ||
    param.authID.substring(0, 3) != param.threeDigit ||
    !re1.test(param.authID.substring(0, 3))
  ) {
    authIDFormatError.value = "※Failed approval. User ID is invalid.";
    isLoading.value = false;
  } else {
    UserApprovalDataService.checkAuthUser(data).then((response: ResponseData) => {
      if (response.data.length !== 0) {
        document.getElementById("btnApproveModalCancel").click();
        if(data.authID == response.data[0].userId){
          alertMessage.value = "Failed approval. User ID is duplicated.";
        }else {
          alertMessage.value = i18n.t("err064");
        }
        alertState.value = "error";
        isLoading.value = false;
      } else {
        insertAuthIDInfo(
          param.authID,
          param.userType,
          param.userID,
          param.empID,
          param.givenNm,
          param.familyNm,
          param.stationCD,
          param.compName,
          param.email
        );
      }
    })
      .catch((e: Error) => {
        alertMessage.value = i18n.t("err068");
        alertState.value = "error";
        isLoading.value = false;
        console.log(e);
      });
  }
}

/** 統合認識ID登録処理 */
const insertAuthIDInfo = (
  strAuthID,
  struserType,
  _struserID,
  strEmpID,
  strGivenNm,
  strFamilyNm,
  strStationCD,
  strCompName,
  stremail
) => {
  isLoading.value = true;
  alertMessage.value = "null";
  alertState.value = "neutral";
  const cscfileData1 = {
    actionFlg: 5,
    userID: strAuthID,
    LName: strFamilyNm,
    FName: strGivenNm,
    employeeID: strEmpID,
    mail: stremail,
    companyName: strCompName,
    stationCode: strStationCD,
    targetScreen: "UserApproval"
  };

  if (struserType == "NewUser") {
    cscfileData1.actionFlg = 1;
  }

  UserInfoDataService.send_authenticationID(cscfileData1)
    .then((resData: ResponseData) => {
      if(resData.data.message != undefined){
        alert(resData.data.message);
        isLoading.value = false;
        if(cscfileData1.actionFlg == 5){
          document.getElementById("btnHiddenReOpen").click();
        }
      }else{
        insertTmpUserInfo(strEmpID, strStationCD, strAuthID);
        document.getElementById("btnApproveModalCancel").click();
      }
    })
    .catch((e: Error) => {
      alertMessage.value = i18n.t("err063");
      alertState.value = "error";
      isLoading.value = false;
      console.log(e);
    });
};

/** TmpUserとTmpUserPemissionのデータをUserとUserPermissionに登録する処理関数 */
const insertTmpUserInfo = (strEmpNo, strStationCD, strAuthID) => {
  isLoading.value = true;
  alertMessage.value = "null";
  alertState.value = "neutral";
  const data = {
    empNo: strEmpNo,
    stationCd: strStationCD,
    authID: strAuthID,
    loginUserId: store.getters.cognitoUserName
  };
  UserApprovalDataService.insertTempUserData(data)
    .then((response: ResponseData) => {
      var apporveResData = response.data;
      const mailData = {
        userId: strEmpNo,
        userType: "NewUser",
        email: targetemail.value,
        userName: targetUserName.value,
        targetMailFormat: "mail_user_approved",
        sendingPattern: "user_approved",
        loginUserId: store.getters.cognitoUserName
      };
      SendEmailService.sendEmail(mailData)
        .then((_) => {
          if(apporveResData.genchiShouninMenuData.length != 0){
            var approvedMenuList = apporveResData.genchiShouninMenuData;
            for(var menuIdx = 0; menuIdx<approvedMenuList.length; menuIdx++){
              const menuApproveMailData = {
                                userId: strAuthID,
                                mainMenuCode: approvedMenuList[menuIdx].mainMenuCode,
                                loginUserId: store.getters.cognitoUserName,
                                email: targetemail.value,
                                userName: targetUserName.value,
                                targetMailFormat: "mail_permission_approved",
                                sendingPattern: "permission_approved",
                                mainMenuName: approvedMenuList[menuIdx].mainMenuName,
                                staionCode: strStationCD
                              };
              SendEmailService.sendEmail(menuApproveMailData)
              .catch((e: Error) => {
                alertMessage.value = "Failed to send notice email of permission approval";
                alertState.value = "error";
                isLoading.value = false;
                console.log(e);
              });
            }
          }
          // SMC管理者へメール送信
          const menuData = {
            userId: strAuthID,
            menuList: apporveResData.normalMenuData
          };
          SendEmailService.sendEmailByMenu(menuData)
            .then((response2: ResponseData) => {
              if (response2.data.length != 0) {
                for (var i = 0; i < response2.data.length; i++) {
                  const smcData = {
                    userId: strAuthID,
                    targetMailFormat: "mail_SMC_manager_notice",
                    sendingPattern: "SMC_manager_notice",
                    email: response2.data[i]['email'],
                    menuList: response2.data[i]['menuList'],
                    loginUserId: store.getters.cognitoUserName
                  };

                  SendEmailService.sendEmail(smcData)
                    .catch((e: Error) => {
                      alertMessage.value = "Failed to send notice email of permission approval";
                      alertState.value = "error";
                      isLoading.value = false;
                      console.log(e);
                    });
                }
              }
              getUserApprovalInfo();
              getPermissionSetInfo();
              alertMessage.value = i18n.t("suc033");
              alertState.value = "success";
            })
            .catch((e: Error) => {
              alertMessage.value = "Failed to send notice email of permission approval";
              alertState.value = "error";
              isLoading.value = false;
              console.log(e);
            });
        })
        .catch((e: Error) => {
          alertMessage.value = "Failed to send completion email of user approval";
          alertState.value = "error";
          isLoading.value = false;
          console.log(e);
        });
    })
    .catch((e: Error) => {
      alertMessage.value = i18n.t("err069");
      alertState.value = "error";
      isLoading.value = false;
      console.log(e);
    });
};

/** 再申請ユーザーの為、承認モダルのユーザー権限承認ボタン押下時の処理関数 */
const btnReAppApprove = (struserId) => {
  isLoading.value = true;
  alertMessage.value = "null";
  alertState.value = "neutral";
  rePermissionInfo.splice(0);

  //ユーザーが選択した権限リスト
  for (var j = 0; j < permissionSetInfo[0].length; j++) {
    for (var k = 0; k < permissionSetInfo[0][j].data.length; k++) {
      if (permissionSetInfo[0][j].data[k].mainMenuCode) {
        const chkFlg = document.getElementById(
          "chk" + permissionSetInfo[0][j].data[k].mainMenuCode
        );
        if (chkFlg.checked == true) {
          rePermissionInfo.push(permissionSetInfo[0][j].data[k].mainMenuCode);
        }
      }
    }
  }

  const data = {
    userId: struserId,
    chkFlg: rePermissionInfo,
    loginUserId: store.getters.cognitoUserName,
    stationCode: store.getters.stationCode
  };
  UserApprovalDataService.approveUserPermission(data)
    .then((response: ResponseData) => {
      const mailData = {
        userId: struserId,
        userType: "ReApplyUser",
        email: targetemail.value,
        userName: targetUserName.value,
        loginUserId: store.getters.cognitoUserName,
        targetMailFormat: "mail_user_approved",
        sendingPattern: "user_approved"
      };
      SendEmailService.sendEmail(mailData)
        .then((_) => {
          var apporveResData = response.data;
          if(apporveResData.genchiShouninMenuData.length != 0){
            var approvedMenuList = apporveResData.genchiShouninMenuData;
            for(var menuIdx = 0; menuIdx<approvedMenuList.length; menuIdx++){
              const menuApproveMailData = {
                                userId: struserId,
                                mainMenuCode: approvedMenuList[menuIdx].mainMenuCode,
                                loginUserId: store.getters.cognitoUserName,
                                email: targetemail.value,
                                userName: targetUserName.value,
                                targetMailFormat: "mail_permission_approved",
                                sendingPattern: "permission_approved",
                                mainMenuName: approvedMenuList[menuIdx].mainMenuName,
                                staionCode: store.getters.stationCode
                              };
              SendEmailService.sendEmail(menuApproveMailData)
              .catch((e: Error) => {
                alertMessage.value = "Failed to send notice email of permission approval";
                alertState.value = "error";
                isLoading.value = false;
                console.log(e);
              });
            }
          }
          // SMC管理者へメール送信
          const menuData = {
            userId: struserId,
            menuList: apporveResData.normalMenuData
          };
          SendEmailService.sendEmailByMenu(menuData)
            .then((response2: ResponseData) => {
              if (response2.data.length != 0) {
                for (var i = 0; i < response2.data.length; i++) {
                  const smcData = {
                    userId: struserId,
                    targetMailFormat: "mail_SMC_manager_notice",
                    sendingPattern: "SMC_manager_notice",
                    email: response2.data[i]['email'],
                    menuList: response2.data[i]['menuList'],
                    loginUserId: store.getters.cognitoUserName
                  };

                  SendEmailService.sendEmail(smcData)
                    .catch((_) => {
                      alertMessage.value = "Failed to send notice email of permission approval";
                      alertState.value = "error";
                      isLoading.value = false;
                    });
                }
              }
              getUserApprovalInfo();
              getPermissionSetInfo();
              alertMessage.value = i18n.t("suc033");
              alertState.value = "success";
            })
            .catch((e: Error) => {
              alertMessage.value = "Failed to send notice email of permission approval";
              alertState.value = "error";
              isLoading.value = false;
              console.log(e);
            });
        })
        .catch((e: Error) => {
          alertMessage.value = "Failed to send completion email of user approval";
          alertState.value = "error";
          isLoading.value = false;
          console.log(e);
        });
    })
    .catch((e: Error) => {
      alertMessage.value = i18n.t("err070");
      alertState.value = "error";
      isLoading.value = false;
      console.log(e);
    });
};

const btnEditAuthID = () => {
  document.getElementById("txtAuthenticationId").disabled = false;
  approveModalBody[0] = targetStation3Digit.value;
}

onUpdated(function () {
  handleResize();
});

const __returned__ = { isLoading, userApprovalInfo, permissionSetInfo, rePermissionInfo, alertMessage, alertState, i18n, title, modalSubject, modalBody, approveModalSubject, approveModalBody, isNoData, userType, isEditableAuthID, targetUserId, threeDigitCode, targetstationCode, targetEmpNo, targetGivenName, targetFamilyName, targetCompanyName, targetemail, targetUserName, targetStation3Digit, oriAuthID, authIDFormatError, isConfirmFlg, editedAuthIDApproveData, handleResize, getUserApprovalInfo, getPermissionSetInfo, modalShow1, checkCheckBox, chkChange, chkHeaderChange, btnClose, showApproveModal, showDenyModel, DenyBtnClk, ApproveBtnClk, confirmAuthIDApprove, EditedAuthIDApprove, insertAuthIDInfo, insertTmpUserInfo, btnReAppApprove, btnEditAuthID, Loading, Alert, AdminNavigation }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})